<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EiAwv8/images/Cover.jpg?1703868059590" alt="This image is the cover for the book Last Days of British Steam"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Days of British Steam
      </h1>
      <p class="bookDescription body article font2">
        <b>A treasury of photos capturing the end of an era in transportation history—the final decade of steam locomotives in Britain.</b><br/><br/>Malcolm Clegg has been taking railway pictures since the early 1960s, and also enjoys access to collections taken by friends who were recording the steam railway scene during this period. In this book, he covers a wide variety of classes of locomotives that were withdrawn during the last decade of steam traction, examples of some of which are now preserved.<br/><br/>This book is a record of his and other peoples’ journeys during the last decade of steam in the 1960s, with photographs and informative captions looking at steam traction in a wide variety of geographical locations around the British Railways network.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Clegg
      </h2>
      
      <p class="authorDescription body article">Malcolm Clegg is a retired British Transport Police Sergeant who served for almost thirty years both as a uniformed and CID officer at various railway and dock locations in England and Wales. Ten years were spent working in London.  Malcolm comes from a railway family, his father was a station master at several locations on the national network and passed on a passion for railways to Malcolm at an early age.  He currently resides in Swansea and his interests include history and photography. In recent years, Malcolm has carried out extensive research and written a number of articles for the British Transport Police History Group (www.btphg.org.uk).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0dcf69d3